import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, Output, EventEmitter, SimpleChanges, ViewChild, OnDestroy} from '@angular/core';
import {ModalDirective} from 'angular-bootstrap-md';
import {debounceTime} from 'rxjs/operators';
import {screenSize as screen_size } from '../../size-detector/ScreenSize';
import {BrowserDetectorService} from '../../../../../data/networking/services/shared/broswer-detector/browser-detector.service';
import {ResizeEvent} from '../../../event-listeners/resize/resize.event';
import {LocalStorageManager} from '../../../../../data/manager/local-storage/local-storage.manager'
import { GoogleTagService } from 'src/app/data/networking/services/shared/google-tag/google-tag.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { setScheduleOrder } from 'src/app/data/actions/scheduler-modal.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrls: ['./basic-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicModalComponent implements OnChanges, OnInit, OnDestroy {
  screenSize = screen_size;
  @Input() modalName = '';
  @Input() status = {open: false, close: false};
  @Input() modalSize = '';
  @Input() eventClick;
  @Input() title = '';
  @Input() titleClass = '';
  @Input() iconSrc = '';
  @Input() iconClass = '';
  @Input() contentClass = '';
  @Input() contentIconClass = '';
  @Input() headerClass = '';
  @Input() bodyClass = '';
  @Input() dialogClass = '';
  @Input() mainClass = '';
  @Input() backDrop: any = true;
  @Input() mobileFullScreen = true;
  @Input() persistXToClose = false;
  @Input() bottomSheetStyle = false;
  @Input() getCustomClasses: any[];
  @Input() loading = false;
  @Input() showBackArrow = false;  
  customClasses: string;
  @Input() showClose = true;
  @Input() options = {
    showFooter: false,
    closeButton: true,
    closeButtonText: 'Cerrar',
    customClass: 'transparent',
  };
  overlay = false;
  basicModalStatus = false;
  @Output('closeModal') closeModal = new EventEmitter();
  @ViewChild('basicModal') basicModal: ModalDirective;
  browser;
  device = [];
  modalStatus: any;
  @Output() closeModalEvent: EventEmitter<string> = new EventEmitter();
  @Output() backArrowClick: EventEmitter<string> = new EventEmitter();  
  schedureSubscritor: Subscription;

  constructor(
              private resizeEvent: ResizeEvent,
              private browserDetector: BrowserDetectorService,
              private lsm: LocalStorageManager,
              private gtm: GoogleTagService,
              private store: Store<AppState>
              ) {
    this.browser = browserDetector.checkBrowser();
  }
  ngOnDestroy(): void {
  }

  hideHeaderAndFooter() {}

  showHeaderAndFooter() {}

  openModal() {
    this.gtm.openModal(this.modalName);
    this.lsm.set('modalStatus', true);
    this.lsm.get('modalStatus');
    this.overlay = true;
    this.basicModalStatus = true;
    if (this.device && this.device[0] === 'iPhone') {
      this.hideHeaderAndFooter();
    }
  }

  hideModal() {
    this.lsm.set('modalStatus', false);
    this.closeModalEvent.emit('closed');
    this.overlay = false;
    this.basicModalStatus = false;
    if (this.device && this.device[0] === 'iPhone') {
      this.showHeaderAndFooter();
    }
    this.closeModal.emit(null);
    this.schedureSubscritor = this.store.select( 'schedule' ).subscribe( ({show})=>{
      if(show){
        this.store.dispatch( setScheduleOrder( {show: false} ) );
      }
    } );
  }

  onResize() {
    this.resizeEvent.currentScreenSize
      .pipe(debounceTime(1000))
      .subscribe(size => { this.screenSize = {...size}; });
      if ( this.device && this.device[0] === 'iPhone') {
        this.showHeaderAndFooter();
      }
  }

  ngOnInit() {
    this.device = this.lsm.get('device');
    this.onResize();
  }

  async isDesktop() {
    const val: any = await this.resizeEvent.currentScreenSize;
    return val.mobile;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.status) {
      if(this.status && this.status.open) {
        this.openModal();
      } else if (this.status && this.status.close) {
          this.hideModal();
      }
    }
  }
}
